var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxBoldPath2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.83 22c-1.54 0-2.68-1.25-2.38-2.58l.52-2.32c.1-.46.51-.78.98-.78h6.09c.47 0 .87.32.98.78l.52 2.31c.32 1.43-.75 2.59-2.39 2.59H9.83zM17.75 14.63c-.37.32-.84.5-1.32.5H7.59c-.49 0-.97-.18-1.33-.51l-1.05-.94c-1.72-1.41-1.73-2.49-.41-4.15l5.23-6.61c.35-.47.79-.77 1.24-.92v4.86c-.01.43.33.77.75.76.42.01.75-.33.76-.76V3.347a.697.697 0 0 1 1.24-.437l5.21 6.62c1.3 1.66 1.25 2.69-.41 4.16l-1.07.94z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldPath2);
export default __webpack_public_path__ + "static/media/vuesax-bold-path-2.0a2cc16345fa9eff34b9a55602d6373b.svg";
export { ForwardRef as ReactComponent };